<div style="width: 100%">
  <div style="padding-top: 10px; margin-left: auto; margin-right: auto;">
<!--    <mat-grid-list cols="1" >-->
<!--      <mat-grid-tile i18n-class="@@dir">-->
<!--        <mat-card style="background: rgba(59, 56, 87, 0.94); height: 100%; width: 100%;">-->
<!--          <mat-card-content>-->
<!--            <div style="padding: 30px;">-->
<!--              <h3 style="padding-top: 150px;" i18n="@@Setting your password.">Setting your password.</h3>-->
<!--              <p i18n="@@....">..................................................................................</p>-->
<!--              <h2 style="padding-top: 40px" i18n="@@Main Organization Name">Main Organization Name</h2>-->
<!--              <p i18n="@@START YOUR PROJECT TODAY">START YOUR PROJECT TODAY</p>-->
<!--            </div>-->
<!--          </mat-card-content>-->
<!--        </mat-card>-->
<!--      </mat-grid-tile>-->
<!--      <mat-grid-tile i18n-class="@@dir">-->
        <mat-card appearance="outlined" class="formCard">
          <h1 i18n="@@Forgot Password">Forgot Password</h1>
          <img src="/logo.png" class="intro-logo">
          <mat-card-content>
            <form style="padding-top: 85px; padding-bottom: 85px;">
              <mat-form-field appearance="outline" class="full-width">
                <input matInput i18n-placeholder="@@Verification Code" placeholder="Verification Code" id="verificationCode" required type="email" maxlength="50" [(ngModel)]="verificationCode" [ngModelOptions]="{standalone: true}">
                <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="full-width">
                <input matInput i18n-placeholder="@@New Password" placeholder="New Password" id="newPassword" required type="password" maxlength="50" [(ngModel)]="password" [ngModelOptions]="{standalone: true}">
              </mat-form-field>
              <span style="font-size: 0.8em; text-align: center; display: block" i18n="@@Password must contain an UPPER CASE and lower case letter and a number.">Password must contain an UPPER CASE and lower case letter and a number.</span>
            </form>
          </mat-card-content>
          <mat-card-actions class="primaryAction">
            <button mat-raised-button color="primary" (click)="onNext()" id="signupSubmit" type="submit" i18n="@@Reset Password">Reset Password</button>
          </mat-card-actions>
          <mat-card-actions class="secondaryAction">
            <button mat-button color="primary" [routerLink]="['/home/resendCode']"><ng-container i18n="navigate to previous screen|Navigation control returning the user to the previous screen. Nothing to do with goods being returned - see the Return id, which is an inventory receipt.@@Go Back">Go Back</ng-container></button>
          </mat-card-actions>
        </mat-card>
<!--      </mat-grid-tile>-->
<!--    </mat-grid-list>-->
  </div>
</div>
